export function coalesceDefined(...values) {
  for (const value of values) {
    if (value !== void 0) {
      return value;
    }
  }
}